var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHearthGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.583,
    height: 18.854,
    viewBox: "0 0 21.583 18.854",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "heart",
    d: "M18.792,28.854l-.381-.317C10.222,21.871,8,19.522,8,15.713A5.689,5.689,0,0,1,13.713,10a6.485,6.485,0,0,1,5.078,2.6A6.485,6.485,0,0,1,23.87,10a5.689,5.689,0,0,1,5.713,5.713c0,3.809-2.222,6.158-10.411,12.823ZM13.713,11.27A4.416,4.416,0,0,0,9.27,15.713c0,3.237,2.031,5.4,9.522,11.49,7.491-6.094,9.522-8.252,9.522-11.49A4.416,4.416,0,0,0,23.87,11.27a5.6,5.6,0,0,0-4.38,2.412l-.7.825-.7-.825A5.6,5.6,0,0,0,13.713,11.27Z",
    transform: "translate(-8 -10)",
    fill: "#2D3040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearthGrey);
export default __webpack_public_path__ + "static/media/hearth-grey.855fead39348f80cb1f4767d57aad7a7.svg";
export { ForwardRef as ReactComponent };